<template>
  <div class="container">
    <div class="right">
      <div class="flex-list">
        <div class="flex">
          <div>
            <el-input
              size="small"
              clearable
              placeholder="请输入敏感词"
              prefix-icon="el-icon-search"
              v-model="flows.keyword"
              @clear="clear"
            >
              <el-button
                slot="append"
                @click="rolesList"
                :disabled="!flows.keyword"
                >搜索</el-button
              >
            </el-input>
          </div>
        </div>
        <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="centerDialogVisible = true"
            >批量添加
          </el-button>
        </div>
      </div>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="敏感词"> </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  @click="handleClick(scope.row)"
                  class="size"
                  type="text"
                  size="small"
                  icon="el-icon-edit-outline"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="text"
                  size="small"
                  @click="handClcikButton(scope.row)"
                  class="size"
                  icon="el-icon-delete"
                  style="padding-left: 15px"
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagingVue
        :Pagination="Pagination"
        :tableData="tableData"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagingVue>

      <div>
        <el-dialog
          title="新建敏感词"
          :visible.sync="centerDialogVisible"
          width="30%"
          modal
          :close-on-click-modal="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="useName"
            :rules="rules"
            ref="useName"
          >
            <el-form-item prop="names" label="敏感词">
              <el-input
                type="textarea"
                :rows="10"
                placeholder=" 请输入敏感词"
                v-model="useName.names"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handCancel">取 消</el-button>
            <el-button type="primary" @click="handConfirm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="编辑敏感词"
          :visible.sync="puppuVisible"
          width="30%"
          modal
          :close-on-click-modal="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="modify"
            :rules="rules"
            ref="modify"
          >
            <el-form-item prop="name" label="敏感词">
              <el-input placeholder="敏感词" v-model="modify.name"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handCancel">取 消</el-button>
            <el-button type="primary" @click="handBttonConfirm"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import pagingVue from "../../../components/Paging/paging.vue";
export default {
  name: "Member_role",
  data() {
    return {
      delete: {
        id: "",
      },
      flows: {
        keyword: "",
        page: "",
      },

      paginationList: {},
      Pagination: {},

      num: "",
      useName: {
        names: "",
      },
      medel: {
        names: "",
      },
      modify: {
        id: "",
        name: "",
      },
      tableData: [],
      centerDialogVisible: false,
      puppuVisible: false,

      rules: {
        names: [
          { required: true, message: "请输入敏感词", trigger: "blur" },
          { min: 2, message: "长度至少2个字符", trigger: "blur" },
        ],
      },
    };
  },

  components: {
    pagingVue,
  },
  mounted() {
    this.rolesList();
  },
  methods: {
    clear() {
      this.rolesList();
    },
    async rolesList() {
      await this.$axios
        .getListData("admin/sensitive-words", this.flows)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let time = res.data.data;
            this.tableData = time.map((v) => {
              return {
                ...v,
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },

    close() {
      this.centerDialogVisible = false;
      this.useName = {};
    },
    handCancel() {
      this.puppuVisible = false;
      this.centerDialogVisible = false;
      this.useName = {};
    },
    //新增敏感词
    handConfirm() {
      this.$refs.useName.validate((valid) => {
        if (valid) {
          let res = this.useName.names.replace(/\n|\r\n/g, "##");
          let conter = res
            .split("##")
            .filter((s) => s && s.trim())
            .join("##");
          let b = conter.replace(/^\"|\"$/g, "").replace(/^\s+|\s+$/g, "");
          this.medel.names = b;
          this.$axios
            .postListData("admin/sensitive-words", this.medel)
            .then((res) => {
              if (res.code === 200) {
                this.centerDialogVisible = false;
                this.rolesList();
                this.useName = {};
              }
            });
        } else {
          return false;
        }
      });
    },
    async handBttonConfirm() {
      await this.$refs.modify.validate((valid) => {
        if (valid) {
          this.$axios
            .postListData("admin/update-sensitive-word", this.modify)
            .then((res) => {
              if (res.code === 200) {
                this.puppuVisible = false;
                this.modify = {};
                this.rolesList();
              }
            });
        } else {
          return false;
        }
      });
    },
    handleClick(e) {
      this.$set(this.modify, "name", e.name);
      this.puppuVisible = true;
      this.modify.id = e.id;
    },
    async handClcikButton(e) {
      this.delete.id = e.id;

      await this.$confirm("是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .getListData("admin/delete-sensitive-word", this.delete)
            .then((res) => {
              if (res.code === 200) {
                if (this.tableData.length > 1) {
                  this.rolesList();
                } else {
                  if (this.flows.page >= 2) {
                    this.flows.page = this.flows.page - 1;
                    this.rolesList();
                  } else {
                    this.rolesList();
                  }
                }
              }
            });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    //分页
    handleCurrentChange(val) {
      this.flows.page = val;
      this.rolesList();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}
/deep/.el-table__empty-text {
  line-height: 53px;
}
/deep/.el-table__empty-block {
  min-height: 53px;
}
/deep/.el-dialog__body {
  padding: 20px;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  display: none;
}
/deep/.el-message-box__headerbtn .el-message-box__close {
  display: none;
  color: #909399;
}
/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}
/deep/.el-table__body {
  width: 100% !important;
}
/deep/.el-select {
  width: 100% !important;
}
/deep/.el-form-item {
  margin-bottom: 12px;
}
/deep/.el-radio-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;

  .right-item {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .distance {
  margin: 10px 0;
}
  .right {
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .flex {
      display: flex;
      align-items: center;
    }
  }
  /deep/.el-dialog__body {
    padding: 20px !important;
  }
}
</style>
